export default [
  {
    path: '/404',
    component: () => import('@/views/admin/error/Error404.vue'),
    meta: { title: '404' }
  },
  {
    name: 'errorRole',
    path: '/error/role',
    component: () => import('@/views/admin/error/ErrorRole.vue'),
    meta: { title: '没有页面权限' }
  }
]
